import type {ChangeEvent} from 'react'
import React, {useCallback} from 'react'
import {useUser} from '../../context/UserContext'
import {Input} from '../form/Input'
import {SpacingWrapper} from '../layout'
import type {ErrorProps} from './Receiver'

interface Props {
  setNewCheckoutEmail: React.Dispatch<React.SetStateAction<string>>
  errors: ErrorProps
}

export default function CheckoutEmailUpdate({
  setNewCheckoutEmail,
  errors,
}: Props): JSX.Element {
  const {user} = useUser()

  const initialValues = user?.email

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
      setNewCheckoutEmail(e.target.value)
    },
    [setNewCheckoutEmail],
  )

  return (
    <SpacingWrapper spacing={20}>
      <Input
        label="Netfang til þess að senda upplýsingar um pöntun"
        name="email"
        type="email"
        onChange={handleChange}
        defaultValue={initialValues}
        withGutter
        showError={!!errors?.email}
        errorMsg={errors?.email}
      />
    </SpacingWrapper>
  )
}
